import React from 'react';
import './index.scss';
import CircularProgress from '@mui/material/CircularProgress';

const LoaderIcon = () => {
	return <div className="in-progress"><CircularProgress /></div>
}

export default LoaderIcon;